import {
	// Global App
	SET_APP_STATE,
	SET_USER,
	SET_RELOGIN,
	SET_EMAIL,
	SET_CURRENT_SCREEN,
	SET_CURRENT_DIVISION,
	SET_CURRENT_QUESTION,
	SET_CURRENT_SONG,
	SET_SHOW_PROOFS,
	SET_SHOW_QUESTIONS_IN_DIVISIONS,
	SET_PROGRESS_MESSAGE,
	SET_PROGRESS_PERCENTAGE,
	
	// AudioPlayer
	SET_IS_AUDIO_PRESENTATION_MODE,
	SET_PLAYER_IS_SHOWN,
	SET_PLAYER_SIZE,
	SET_AUDIO_IS_READY,
	SET_AUDIO_QUESTION,
	SET_AUDIO_LYRICS,
	SET_AUDIO_PULSE,
	SET_AUDIO_IS_PLAYING,
	SET_AUDIO_IS_KARAOKE_MODE,
	SET_AUDIO_IS_LOOPING,
	SET_AUDIO_HAS_ALT,
	SET_AUDIO_IS_ALT,
	SET_AUDIO_IS_DUCKING,
	SET_AUDIO_IS_SCRUBBING,
	SET_AUDIO_IS_AUTO_ADVANCE,
	SET_AUDIO_RATE,
	SET_AUDIO_ERROR,
} from '../actions/AppActions';
import {
	PLAYER_SIZE__SMALL,
	PLAYER_SIZE__BIG,
} from '../../constants/PlayerSizes';
import {
	RATE__1,
} from '../../constants/Rates';
import getIsMobile from '../../OneHat/functions/getIsMobile';
import _ from 'lodash';

const defaultState = {
	// Global App
	appState: 'active',
	user: null,
	relogin: false,
	email: null,
	currentScreen: null,
	currentDivision: null,
	currentQuestion: null,
	currentSong: null,
	showProofs: false,
	showQuestionsInDivisions: false,
	progressMessage: null,
	progressPercentage: 100,

	// audioPlayer
	playerSize: PLAYER_SIZE__BIG,
	playerIsShown: false,
	audioIsReady: false,
	audioIsPlaying: false,
	audioIsLooping: false,
	audioIsKaraokeMode: false,
	audioHasAlt: false,
	audioIsAlt: false,
	audioIsDucking: false,
	audioIsScrubbing: false,
	audioIsAutoAdvance: !getIsMobile(), // true on web, false on mobile
	audioIsLyricsMode: true,
	audioRate: RATE__1,
	audioTime: 0,
	audioDuration: 0,
	audioPercentage: 0,
	audioError: null,
	audioQuestion: null,
	audioLyrics: null,
};

export default function(state = defaultState, action) {
	let newState = _.assign({}, state);
	switch (action.type) {
		// Global App
		case SET_APP_STATE:
			newState.appState = action.appState;
			break;
		case SET_USER:
			newState.user = action.user;
			break;
		case SET_RELOGIN:
			newState.relogin = action.bool;
			break;
		case SET_EMAIL:
			newState.email = action.email;
			break;
		case SET_CURRENT_SCREEN:
			newState.currentScreen = action.currentScreen;
			break;
		case SET_CURRENT_DIVISION:
			newState.currentDivision = action.division;
			break;
		case SET_CURRENT_QUESTION:
			newState.currentQuestion = action.question;
			break;
		case SET_CURRENT_SONG:
			newState.currentSong = action.song;
			break;
		case SET_SHOW_PROOFS:
			newState.showProofs = action.bool;
			break;
		case SET_SHOW_QUESTIONS_IN_DIVISIONS:
			newState.showQuestionsInDivisions = action.bool;
			break;
		case SET_PROGRESS_MESSAGE:
			newState.progressMessage = action.message;
			break;
		case SET_PROGRESS_PERCENTAGE:
			newState.progressPercentage = action.percentage;
			break;

		// Audio Player
		case SET_IS_AUDIO_PRESENTATION_MODE:
			newState.audioIsLyricsMode = action.bool;
			break;
		case SET_PLAYER_SIZE:
			newState.playerSize = action.size;
			break;
		case SET_PLAYER_IS_SHOWN:
			newState.playerIsShown = action.bool;
			break;
		case SET_AUDIO_IS_READY:
			newState.audioIsReady = action.bool;
			break;
		case SET_AUDIO_QUESTION:
			newState.audioQuestion = action.question;
			break;
		case SET_AUDIO_LYRICS:
			newState.audioLyrics = action.lyrics;
			break;
		case SET_AUDIO_PULSE:
			const pulse = action.pulse;
			newState.audioTime = pulse.time;
			newState.audioDuration = pulse.duration;
			newState.audioPercentage = pulse.percentage;
			break;
		case SET_AUDIO_IS_PLAYING:
			newState.audioIsPlaying = action.bool;
			break;
		case SET_AUDIO_IS_KARAOKE_MODE:
			newState.audioIsKaraokeMode = action.bool;
			break;
		case SET_AUDIO_IS_LOOPING:
			newState.audioIsLooping = action.bool;
			break;
		case SET_AUDIO_HAS_ALT:
			newState.audioHasAlt = action.bool;
			break;
		case SET_AUDIO_IS_ALT:
			newState.audioIsAlt = action.bool;
			break;
		case SET_AUDIO_IS_DUCKING:
			newState.audioIsDucking = action.bool;
			break;
		case SET_AUDIO_IS_SCRUBBING:
			newState.audioIsScrubbing = action.bool;
			break;
		case SET_AUDIO_IS_AUTO_ADVANCE:
			newState.audioIsAutoAdvance = action.bool;
			break;
		case SET_AUDIO_RATE:
			newState.audioRate = action.rate;
			break;
		case SET_AUDIO_ERROR:
			newState.audioError = action.error;
			break;
	}

	return newState;
}

